import React from "react";
import { OverlayTrigger, Tooltip } from "@themesberg/react-bootstrap";
import { TruncatedSpan } from "./style";

export const TruncatedText = ({ text, maxLength = 30 }) => {
  if (!text || text === "NA") return <span>NA</span>;

  if (text.length < maxLength) {
    return <span>{text}</span>;
  }

  const truncated =
    text.length > maxLength ? `${text.substring(0, maxLength)}...` : text;

  return (
    <OverlayTrigger placement="top" overlay={<Tooltip>{text}</Tooltip>}>
      <TruncatedSpan>{truncated}</TruncatedSpan>
    </OverlayTrigger>
  );
};